import React from 'react';

import {
  EmbeddedBuilderEntity,
  EmbeddedBuilderMode,
  IEmbeddedBuilderProps
} from 'components/EmbeddedBuilder';

export interface IBuilderRegistryEntry {
  load: () => Promise<{ default: React.ComponentType<IEmbeddedBuilderProps> }>;
  modes: EmbeddedBuilderMode[];
  defaultStep?: string;
}

export type BuilderRegistry = Partial<Record<EmbeddedBuilderEntity, IBuilderRegistryEntry>>;

export const builderRegistry: BuilderRegistry = {
  audience: {
    load: () => import('containers/Audience/pages/AudienceEmbeddedBuilder'),
    modes: ['create-prefill', 'edit']
  },
  campaign: {
    load: () => import('pages/campaign/CampaignEmbeddedBuilder'),
    modes: ['edit'],
    defaultStep: 'review'
  },
  loyalty_program: {
    load: () => import('containers/Loyalty/pages/LoyaltyEmbeddedBuilder'),
    modes: ['edit'],
    defaultStep: 'review'
  },
  reward: {
    load: () => import('pages/reward/RewardEmbeddedBuilder'),
    modes: ['edit'],
    defaultStep: 'review'
  },
  rule: {
    load: () => import('containers/Rule/pages/RuleEmbeddedBuilder'),
    modes: ['edit'],
    defaultStep: 'review'
  }
};
